import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

const SERVER_TIMEZONE = 'Asia/Shanghai'

/**
 * 将后端返回的时间字符串（Asia/Shanghai）转换为后台指定的显示时区
 * @param {string} timeStr - 后端返回的时间字符串，如 "2026-04-23 14:00:00"
 * @param {string} [displayTz] - 目标显示时区，不传则从 store 中获取
 * @param {string} [format] - 输出格式，默认 'YYYY-MM-DD HH:mm:ss'
 * @returns {string}
 */
export function formatTime(timeStr, displayTz, format) {
  if (!timeStr) return ''
  const fmt = format || 'YYYY-MM-DD HH:mm:ss'
  const tz = displayTz || getDisplayTimezone()
  try {
    return dayjs.tz(timeStr, SERVER_TIMEZONE).tz(tz).format(fmt)
  } catch (e) {
    console.error('formatTime error:', e, timeStr)
    return timeStr
  }
}

/**
 * 将时间戳（毫秒）转换为后台指定的显示时区
 * @param {number} ts - 时间戳（毫秒）
 * @param {string} [displayTz] - 目标显示时区
 * @param {string} [format] - 输出格式
 * @returns {string}
 */
export function formatTimestamp(ts, displayTz, format) {
  if (!ts) return ''
  const fmt = format || 'YYYY-MM-DD HH:mm:ss'
  const tz = displayTz || getDisplayTimezone()
  try {
    return dayjs(ts).tz(tz).format(fmt)
  } catch (e) {
    console.error('formatTimestamp error:', e, ts)
    return ''
  }
}

/**
 * 获取当前显示时区（从 localStorage 读取，与 store 同步）
 */
export function getDisplayTimezone() {
  return localStorage.getItem('displayTimezone') || 'Asia/Shanghai'
}

/**
 * 设置显示时区（同时写 localStorage）
 */
export function setDisplayTimezone(tz) {
  localStorage.setItem('displayTimezone', tz)
}

export { dayjs, SERVER_TIMEZONE }
